import Item from "Components/Item";
import { FC } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { ScrollMessage } from "./Results.styled";

interface Props {
  results: any;
  getMoreResults: any;
  total: number;
}

const Results: FC<Props> = ({ results, total, getMoreResults }) => {
  if (!results) {
    return null;
  }
  if (!total) {
    return null;
  }
  return (
    <div style={{ marginBottom: 20 }}>
      <InfiniteScroll
        dataLength={results.length}
        next={getMoreResults}
        hasMore={results.length < total}
        loader={<ScrollMessage> Loading...</ScrollMessage>}
        endMessage={<ScrollMessage>Nothing more to show</ScrollMessage>}
      >
        {results?.map((item: any, i: number) => {
          return <Item key={i} size={10} article={item} />;
        })}
      </InfiniteScroll>
    </div>
  );
};

export default Results;
